module.exports = __webpack_public_path__ + "static/media/expand-more-black-Icon.485be257.svg";